export default "__VITE_ASSET__D_kzIKF7__"